module.exports = __webpack_public_path__ + "static/media/DSC08921_180531_7.9fb2c756.jpg";